import { ButtonBase, ButtonBaseProps } from '@mui/material';

import { PlusIcon } from '@ocx/ui-icons';

export type PlusButtonProps = {
  onClick: ButtonBaseProps['onClick'];
  name?: string;
};

export const PlusButton = ({ onClick, name }: PlusButtonProps) => {
  return (
    <ButtonBase
      name={name}
      onClick={onClick}
      sx={{
        width: 32,
        height: 32,
        borderRadius: 2,
        backgroundColor: 'action.selected',
        color: 'text.primary',
      }}>
      <PlusIcon />
    </ButtonBase>
  );
};
